/**
 * 报价清单管理组件
 */

import CNF from '../../incs/Config';
import { useState, useCallback } from 'react';
import { Table, Button, InputNumber, Input } from 'antd';
import { MinusOutlined } from '@ant-design/icons';
import { winHeight, winWidth } from '../../incs/FunHelper.js';

import HistoryOfferList from './HistoryOfferList.js';
const OfferList = (props) => {
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);

    const handleSetOpen = useCallback((value = false, record = null) => {
        setRecord(record);
        setOpen(value);
    }, []);

    const columns = [
        {
            title: '', key: 'operation', fixed: 'left', width: 50,
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ height: 20 }}
                icon={<MinusOutlined />}
                onClick={() => { props.removeProduct(record); }}></Button>
        },
        {
            title: '产品编码', key: 'number', fixed: 'left', width: 140,
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: 0, border: 0, height: 22 }}
                onClick={() => { handleSetOpen(true, record); }}>{record.number}</Button>
        },
        { title: '产品名称', dataIndex: 'name', key: 'name', ellipsis: true, width: 300, },
        { title: '规格型号', dataIndex: 'model', key: 'model', ellipsis: true, width: 325, },
        { title: '品牌', dataIndex: 'brand', key: 'brand', ellipsis: true, width: 150, },
        { title: '单位', dataIndex: 'unit', key: 'unit', ellipsis: true, width: 80, },
        { title: '参数', dataIndex: 'description', key: 'description', ellipsis: true, width: 450, },
        {
            title: '税点', key: 'tax_point', width: 100,
            render: function (record) {
                return <InputNumber
                    onChange={(value) => {
                        props.updateTaxPoint(record, value);
                    }}
                    value={record.tax_point}
                    size='small'
                    min={0}
                    step='1'
                    style={{ width: '100%' }}
                />
            }
        },
        { title: '税金', dataIndex: 'tax_amount', key: 'tax_amount', width: 130, },
        {
            title: '备注', key: 'remarks', ellipsis: true, width: 450,
            render: function (record) {
                return <Input
                    onChange={(e) => {
                        props.updateRemarks(record, e.target.value);
                    }}
                    value={record.remarks}
                    placeholder='备注'
                    style={{ width: '100%', height: 25 }}
                />
            }
        },
        { title: '初始单价(元)', dataIndex: 'init_price', key: 'init_price', width: 130, },
        {
            title: '数量', fixed: 'right', key: 'count', width: 100,
            render: function (record) {
                return <InputNumber
                    onChange={(value) => {
                        props.updateCount(record, value);
                    }}
                    value={record.count}
                    size='small'
                    min={0}
                    step='0.01'
                    style={{ width: '100%' }}
                />
            }
        },
        {
            title: '单价(元)', fixed: 'right', key: 'price', width: 130,
            render: function (record) {
                return <InputNumber
                    onChange={(value) => {
                        props.updatePrice(record, value);
                    }}
                    value={record.price}
                    size='small'
                    min={0}
                    step='0.01'
                    style={{ width: '100%' }}
                />
            }
        },
        { title: '总价(元)', dataIndex: 'amount', key: 'amount', fixed: 'right', width: 150, },
    ];

    //  核定
    const columns2 = [
        {
            title: '', key: 'key', fixed: 'left', width: 50,
            render: function (record) {
                return <Button
                    type='link'
                    style={{ padding: 0, height: 20 }}
                    icon={<MinusOutlined />}
                    disabled={true}
                    onClick={() => {
                        props.removeProduct(record);
                    }}></Button>
            }
        },
        { title: '产品编码', dataIndex: 'number', key: 'number', fixed: 'left', width: 140, },
        { title: '产品名称', dataIndex: 'name', key: 'name', ellipsis: true, width: 300, },
        { title: '型号', dataIndex: 'model', key: 'model', ellipsis: true, width: 325, },
        { title: '品牌', dataIndex: 'brand', key: 'brand', ellipsis: true, width: 150, },
        { title: '单位', dataIndex: 'unit', key: 'unit', ellipsis: true, width: 80, },
        { title: '参数', dataIndex: 'description', key: 'description', ellipsis: true, width: 450, },
        { title: '税点', dataIndex: 'tax_point', key: 'tax_point', width: 100, },
        { title: '税费', dataIndex: 'tax_amount', key: 'tax_amount', width: 130, },
        {
            title: '审定税点', key: 'audited_tax_point', width: 100,
            render: function (record) {
                return <InputNumber
                    onChange={(value) => {
                        props.updateTaxPoint(record, value);
                    }}
                    value={record.audited_tax_point}
                    size='small'
                    min={0}
                    step='1'
                    style={{ width: '100%' }}
                />
            }
        },
        { title: '审定税费', dataIndex: 'audited_tax_amount', key: 'audited_tax_amount', width: 130, },
        { title: '备注', dataIndex: 'remarks', key: 'remarks', ellipsis: true, width: 450, },
        { title: '初始单价(元)', dataIndex: 'init_price', key: 'init_price', width: 130, },
        { title: '数量', dataIndex: 'count', key: 'count', width: 100, },
        { title: '单价(元)', dataIndex: 'price', key: 'price', width: 130, },
        { title: '总价(元)', dataIndex: 'amount', key: 'amount', width: 150, },
        {
            title: '审定数量', fixed: 'right', key: 'audited_count', width: 100,
            render: function (record) {
                return <InputNumber
                    onChange={(value) => {
                        props.updateCount(record, value);
                    }}
                    value={record.audited_count}
                    size='small'
                    min={0}
                    step='0.01'
                    style={{ width: '100%' }}
                />
            }
        },
        {
            title: '审定单价(元)', fixed: 'right', key: 'audit_price', width: 130,
            render: function (record) {
                return <InputNumber
                    onChange={(value) => {
                        props.updatePrice(record, value);
                    }}
                    value={record.audited_price}
                    size='small'
                    min={0}
                    step='0.01'
                    style={{ width: '100%' }}
                />
            }
        },
        { title: '审定合计(元)', dataIndex: 'audited_amount', key: 'audit_amount', fixed: 'right', width: 150, },
    ];
    let subtotalAmount = 0;       // 金额小计
    let subtotalTaxAmount = 0;    // 税费小计
    for (let i = 0; i < props.dataLists.length; i++) {

        if (props.operation === CNF.actionName.AUDIT) {
            //  审定小计
            subtotalAmount += parseFloat(props.dataLists[i].audited_amount);
            subtotalTaxAmount += parseFloat(props.dataLists[i].audited_tax_amount);
        } else {
            //  报价小计
            subtotalAmount += parseFloat(props.dataLists[i].amount);
            subtotalTaxAmount += parseFloat(props.dataLists[i].tax_amount);
        }
    }
    return (
        <div style={{ width: winWidth > 200 ? winWidth - 245 : winWidth - 45, marginBottom: 20, }}>
            <Table
                columns={props.operation === CNF.actionName.AUDIT ? columns2 : columns}
                size='small'
                style={{ width: '100%' }}
                dataSource={props.dataLists}
                // virtual
                scroll={{
                    x: winWidth > 200 ? winWidth - 245 : winWidth - 45,
                    y: props.operation === CNF.actionName.AUDIT ? winHeight - 418 : (winHeight - 358) / 2 - 60,
                }}
                rowKey={(record) => record.key}
                bordered={true}
                pagination={false}
                summary={() => (
                    <Table.Summary fixed='bottom'>
                        {
                            // 若报价分类数量>1，则添加金额小计
                            props.offerSorts.length > 1 && <Table.Summary.Row key='subtotal-amount'>
                                <Table.Summary.Cell index={0} colSpan={props.operation === CNF.actionName.AUDIT ? 17 : 12}>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell fixed='right' index={props.operation === CNF.actionName.AUDIT ? 17 : 12}>金额小计(元)：</Table.Summary.Cell>
                                <Table.Summary.Cell fixed='right' index={props.operation === CNF.actionName.AUDIT ? 18 : 13}>{subtotalAmount.toFixed(CNF.DPL)}</Table.Summary.Cell>
                            </Table.Summary.Row>
                        }
                        {
                            // 若报价分类数量>1且有税，则添加税费小计
                            props.offerSorts.length > 1 && subtotalTaxAmount > 0 && <Table.Summary.Row key='subtotal-tax'>
                                <Table.Summary.Cell index={0} colSpan={props.operation === CNF.actionName.AUDIT ? 17 : 12}>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell fixed='right' index={props.operation === CNF.actionName.AUDIT ? 17 : 12}>税费小计(元)：</Table.Summary.Cell>
                                <Table.Summary.Cell fixed='right' index={props.operation === CNF.actionName.AUDIT ? 18 : 13}>{subtotalTaxAmount.toFixed(CNF.DPL)}</Table.Summary.Cell>
                            </Table.Summary.Row>
                        }
                        <Table.Summary.Row key='total-amount' style={{ fontWeight: 'bold' }}>
                            <Table.Summary.Cell index={0} colSpan={props.operation === CNF.actionName.AUDIT ? 17 : 12}>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell fixed='right' index={props.operation === CNF.actionName.AUDIT ? 17 : 12}>金额计合(元)：</Table.Summary.Cell>
                            <Table.Summary.Cell fixed='right' index={props.operation === CNF.actionName.AUDIT ? 18 : 13}>{props.amount}
                                {/* <InputNumber
                                            onChange={(value)=>{
                                                props.changeAmount(value);
                                            }}
                                            value={props.amount}
                                            size='small'
                                            min={0}
                                            step='0.01'
                                            style={{ width: '100%' }} 
                                        /> */}
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                        {
                            props.taxAmount > 0 && <Table.Summary.Row key='total-tax' style={{ fontWeight: 'bold' }}>
                                <Table.Summary.Cell index={0} colSpan={props.operation === CNF.actionName.AUDIT ? 17 : 12}>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell fixed='right' index={props.operation === CNF.actionName.AUDIT ? 17 : 12}>税费合计(元)：</Table.Summary.Cell>
                                <Table.Summary.Cell fixed='right' index={props.operation === CNF.actionName.AUDIT ? 18 : 13}>{props.taxAmount}</Table.Summary.Cell>
                            </Table.Summary.Row>
                        }
                        <Table.Summary.Row key='grand-total' style={{ fontWeight: 'bold' }}>
                            <Table.Summary.Cell index={0} colSpan={props.operation === CNF.actionName.AUDIT ? 17 : 12}>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell fixed='right' index={props.operation === CNF.actionName.AUDIT ? 17 : 12}>总计(元)：</Table.Summary.Cell>
                            <Table.Summary.Cell fixed='right' index={props.operation === CNF.actionName.AUDIT ? 18 : 13}>
                                {(parseFloat(props.amount) + parseFloat(props.taxAmount)).toFixed(CNF.DPL)}
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                )}
            />
            {
                record && <HistoryOfferList
                    open={open}
                    setOpen={handleSetOpen}
                    record={record}
                />
            }
        </div>
    );
}

export default OfferList